export default "__VITE_ASSET__dad6d3d3__"